/**
 * Is this session Beatly staff? The same GET /v1/me the staff bar reads (shared cache key). `null` while it
 * loads — callers treat that as "not yet", so staff-only parts appear a moment later rather than flash for a client.
 */
import { useQuery } from '@tanstack/react-query';
import { coworkApi } from '@/cowork/omniad/api/coworkApi';

export function useStaffState(): { staff: boolean | null; failed: boolean } {
  const me = useQuery({ queryKey: ['cowork', 'me'], queryFn: () => coworkApi.staffScope.me(), staleTime: 5 * 60_000, retry: false });
  // Unknown until /v1/me answers; an error stays unknown (a staff member must not lose ?new=proposal to a blip).
  if (me.isPending || me.isError) return { staff: null, failed: me.isError };
  return { staff: !!me.data?.staff, failed: false };
}

export function useIsStaff(): boolean | null {
  return useStaffState().staff;
}
